'use client'
import React  from 'react'
import { observer } from 'mobx-react-lite'

import { ChevronRight } from 'lucide-react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@hanzo/ui/primitives'
import { Box, cn, css } from '@hanzo/ui'
import { useCommerce, CartPanel, formatCurrencyValue } from '@hanzo/commerce' 

const CartAccordian: React.FC<{
  icon?: React.ReactNode
  clx?: string
  triggerClx?: string
  panelClx?: string
  scrollAfter: number
  scrollHeightClx: string
}> = observer(({
  icon,
  clx='',
  panelClx='',
  triggerClx='',
  scrollAfter,
  scrollHeightClx
}) => { 
  const cmmc = useCommerce()
  return (
    <Accordion type="single" collapsible className={clx}>
      <AccordionItem value="cart" className='w-full border-b-0'>
        <AccordionTrigger className="!no-underline group flex justify-between ">
          <Box className='flex gap-0 items-center'>
            {icon}
            <Box tag="h5" className='text-sm sm:text-xl grow'>
              <Box tag="span" className='group-data-[state=open]:hidden' >Order Total:</Box>
              <Box tag="span" className='group-data-[state=closed]:hidden' >Your Order</Box>
            </Box>
          </Box>
          <Box className='flex gap-1 items-center'>
            <Box tag="h5" className='text-sm sm:text-xl grow truncate'>{formatCurrencyValue(cmmc.promoAppliedCartTotal)}</Box>
            <ChevronRight style={css('h-5 w-5 -mr-2 shrink-0 transition-transform duration-200 group-data-[state=open]:rotate-90')} />
          </Box>
        </AccordionTrigger>
        <AccordionContent className='data-[state=open]:mb-4'>
          <CartPanel 
            className={cn('w-full', panelClx)} 
            scrollAfter={scrollAfter}
            scrollHeightClx={scrollHeightClx}
            listClx='mt-0'
            itemClx='mt-0.5 mb-0'
            totalClx='sticky px-1 pr-2 border-t -bottom-[1px] bg-background'
            showShipping
            showPromoCode
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
})

export default CartAccordian
